export default class QuestionModel {
  /* tslint:disable:variable-name */
  public _id: string
  public title: string
  public content: string
  public created_at: Date
  public updated_at: Date

  constructor() {
    this._id = ''
    this.title = ''
    this.content = ''
    this.created_at = new Date()
    this.updated_at = new Date()
  }
}
